<template>
  <div class="w-screen min-w-full h-screen min-h-screen flex items-center justify-center bg-white">
    <div>
      <div class="flex items-center justify-center my-24 -mt-28">
        <img
          src="/img/TeeWizLogo.png"
          class="w-20 select-none"
        >
      </div>
      <div class="p-9 pl-10 pr-10 border rounded-lg shadow-lg bg-white">
        <div
          v-if="showValidation && errors.length > 0"
          class="mt-6"
          style="max-width: 20rem;"
        >
          <ErrorAlert
            :title="errorTitle()"
            :items="errors"
          />
        </div>

        <div v-if="loginFailed">
          Login failed
        </div>


        <div :class="showValidation && errors.length > 0?'mt-4':'mt-0'">
          <Email
            class="w-80"
            label="Email or Username"
            :username="true"
            :required="true"
            @errors="setEmailErrors"
            @input="updateEmail"
          />
        </div>


        <div class="mt-4">
          <Password
            class="w-80"
            :required="true"
            @errors="setPasswordErrors"
            @input="updatePassword"
          />
        </div>

        <div class="mt-6">
          <PrimaryButton
            text="Log in"
            :width-full="true"
            :loading="loading"
            @click="login"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Email from '@/app/shared/components/form/fields/email.vue';
import Password from '@/app/shared/components/form/fields/password.vue';
import PrimaryButton from '@/app/shared/components/base/button/primaryButton.vue';
import ErrorAlert from '@/app/shared/components/alerts/errorAlert.vue';
import { Authenticate } from '@/app/shared/services/accountService/accountService';
import { IsTenantAvailable, GetAll } from '@/app/shared/services/tenantService/tenantService';

export default {
  name: 'Login',

  components: {
    Email,
    Password,
    PrimaryButton,
    ErrorAlert,
  },


  data() {
    return {
      loading: false,

      email: '',
      password: '',

      emailErrors: [],
      passwordErrors: [],
      showValidation: false,
      loginFailed: false,
    };
  },

  computed: {
    errors() {
      let array = [];
      array = array.concat(this.emailErrors);
      array = array.concat(this.passwordErrors);
      return array;
    },
  },

  mounted() {
    IsTenantAvailable('TestGolfGroup').then((data) => {

    });
  },

  methods: {
    async login() {
      this.loginFailed = false;
      if (this.errors.length === 0) {
        this.showValidation = false;
        this.loading = true;
        
        // Extract tenantId from query string and save to store/localStorage
        try {
          const urlParams = new URLSearchParams(window.location.search);
          const queryTenantId = urlParams.get('tenantId');
          if (queryTenantId) {
            const tenantId = parseInt(queryTenantId, 10);
            if (!isNaN(tenantId)) {
              this.$store.commit('setTenant', tenantId);
            }
          }
        } catch (e) {
          // If URL parsing fails, continue with existing tenantId
        }
        
        // tenantId will be read from query string or localStorage in accountService.js
        Authenticate(this.email, this.password).then((data) => {
          if (data === undefined) {
            this.loading = false;
            this.loginFailed = true;
          } else {
            this.$store.dispatch('setAccessToken', data).then(() => {
              this.$store.dispatch('getUserLoginInformation').then(() => {
                // Load clubs before navigating to ensure they're available
                this.$store.dispatch('getAvailableClubs').then(() => {
                  this.$router.push('/');
                });
              });
            });
          }
        }).catch(() => {
          this.loading = false;
          this.loginFailed = true;
          alert('Failed to login. Please ensure details are valid.');
        });
      } else {
        this.showValidation = true;
      }
    },

    errorTitle() {
      const { length } = this.errors;
      if (length === 1) {
        return 'There is an error with your details';
      }
      return `There are ${length} errors with your details`;
    },

    updateEmail(email) {
      this.email = email;
    },

    updatePassword(password) {
      this.password = password;
    },

    setEmailErrors(errors) {
      this.emailErrors = errors;
    },

    setPasswordErrors(errors) {
      this.passwordErrors = errors;
    },
  },

};
</script>
